import supabase from "./Supabase";

export async function getPlatScripts(
    table = "platinum-files"
) {
    const allFiles: any[] = [];
    const limit = 1000;
    let offset = 0;
    let hasMore = true;

    while (hasMore) {
        const { data, error } = await supabase
            .storage
            .from(table)
            .list("", {
                limit: limit,
                offset: offset,
                sortBy: { column: 'name', order: 'asc' },
            });

        if (error) {
            console.error('Error fetching files:', error);
            break;
        }

        if (data && data.length > 0) {
            allFiles.push(...data);
            offset += limit;
            hasMore = data.length === limit;
        } else {
            hasMore = false;
        }
    }

    return allFiles;
}